import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative min-h-screen flex-col" }

import {
  onBeforeMount,
  onBeforeUnmount,
} from 'vue';
import BusNotification from '@/components/App/BusNotification.vue';
import AppFooter from '@/components/App/Footer/AppFooter.vue';
import CustomLoader1 from '@/components/Helper/Loader/CustomLoader1.vue';
import {
  viewportBreakpoint,
} from '@/helpers';
import {
  useStore,
} from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

let resizedBreakpointEventHandler: (e: Event) => void;

const appStore = useStore.app;

onBeforeMount(() => {
  resizedBreakpointEventHandler = (): void => {
    const resizedBreakpoint = viewportBreakpoint();

    if (resizedBreakpoint !== appStore.breakpoint) {
      appStore.breakpoint = resizedBreakpoint;
    }
  };

  window.addEventListener('resize', resizedBreakpointEventHandler);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', resizedBreakpointEventHandler);
});

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", null, [
      _createVNode(BusNotification),
      _createElementVNode("div", null, [
        (_unref(appStore).isLoading)
          ? (_openBlock(), _createBlock(CustomLoader1, {
              key: 0,
              class: "modal modal-open"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_RouterView)
      ])
    ]),
    (_unref(appStore).isBootstrapped
        && !_unref(appStore).isLoading)
      ? (_openBlock(), _createBlock(AppFooter, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}
}

})